// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","whyGoustoContainer":"Gef73fa","pricePerServing":"G4899c1 G13d4db","CTAContainer":"Ge81334"};